/**
 * Settings Service - API Functions
 * Pure API calls without React dependencies
 */

import { get, patch } from '@/services/shared/client'
import type {
  Settings,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '@/types/settings'

// ==================== API Functions ====================

/**
 * Get current user settings
 * Used to refresh settings after backend syncs them
 */
export async function getSettings(): Promise<Settings> {
  const response = await get<{
    success: boolean
    data: { settings: Settings }
  }>('/user/settings')
  return response.data.settings
}

/**
 * Update user settings
 * Triggered by manual save button on settings page
 */
export async function updateSettings(
  data: Partial<UpdateSettingsRequest>
): Promise<UpdateSettingsResponse> {
  return await patch<UpdateSettingsResponse>('/user/settings', data)
}
